module.exports = __webpack_public_path__ + "static/img/logo_ktiebao@2x.4287631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/KtbPlatformInfoMin/logo_ktiebao@2x.png
// module id = v6oZ
// module chunks = 70